import React from 'react';
import { styled } from 'styled-components';
import { ContainerStyle } from './LivestreamTeaser.styles';
import { Colors } from '../../../../../play-core/styles/Colors';
import { pulsate } from '../../../../../play-core/styles/pulsate';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { AspectPlaceholder } from '../Placeholder/AspectPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const LivestreamTeaserPlaceholder = () => {
  const {
    usePreview
  } = useVideoConfig();
  return /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsx(AspectPlaceholder, {
      aspectRatio: 16 / 9,
      isPreview: usePreview
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "LivestreamTeaserPlaceholder__Layout",
  componentId: "sc-25ef72-0"
})(["", ";height:88px;box-sizing:content-box;background-color:", ";animation:", " 1s ease-in-out infinite alternate;"], ContainerStyle, Colors.GREY_2a2a2a, pulsate);